function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1928(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 33.14,
    height: 20.23,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 10.115
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.23,
    width: 33.14,
    height: 22.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2585714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 31.634999999999998
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 43.04,
    width: 33.14,
    height: 26.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 56.19
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.35,
    width: 33.14,
    height: 26.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.326
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 82.66499999999999
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95.98,
    width: 33.14,
    height: 28.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.814
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 110.05000000000001
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 124.12,
    width: 33.14,
    height: 29.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 138.925
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 153.73,
    width: 33.14,
    height: 29.98,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.996666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 168.72
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 183.71,
    width: 33.14,
    height: 33.03,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 200.22500000000002
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.74,
    width: 33.14,
    height: 33.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 233.3
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 249.87,
    width: 33.14,
    height: 34.1,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 266.92
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.97,
    width: 33.14,
    height: 39.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.734285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 303.58000000000004
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 323.2,
    width: 33.14,
    height: 39.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 342.95
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 362.7,
    width: 33.14,
    height: 40.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.523333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 382.755
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 402.81,
    width: 33.14,
    height: 46.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.734285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 425.82
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 448.83,
    width: 33.14,
    height: 46.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 472.215
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 495.59,
    width: 33.14,
    height: 48.44,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 519.81
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 544.04,
    width: 33.14,
    height: 50.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0127272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 569.4
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 594.76,
    width: 33.14,
    height: 51.75,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.523333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 620.635
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 646.51,
    width: 33.14,
    height: 53.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.523333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 16.57,
    y: 673.255
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 0,
    width: 37.96,
    height: 47.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.326666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.120000000000005,
    y: 23.625
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.1,
    y: 0,
    width: 38.35,
    height: 47.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.27499999999999,
    y: 23.625
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.45,
    y: 0,
    width: 38.5,
    height: 47.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.7,
    y: 23.625
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.95,
    y: 0,
    width: 38.76,
    height: 47.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.32999999999998,
    y: 23.625
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.71,
    y: 0,
    width: 39.44,
    height: 47.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.573333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 206.43,
    y: 23.625
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.15,
    y: 0,
    width: 45.01,
    height: 47.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5009999999999994
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.655,
    y: 23.625
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.17,
    y: 0,
    width: 45.42,
    height: 47.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.046666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.88,
    y: 23.625
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.59,
    y: 0,
    width: 48.15,
    height: 47.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.66499999999996,
    y: 23.625
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.73,
    y: 0,
    width: 51.12,
    height: 47.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.29,
    y: 23.625
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.85,
    y: 0,
    width: 52.72,
    height: 47.25,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.21000000000004,
    y: 23.625
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.57,
    y: 0,
    width: 56.54,
    height: 47.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 496.84,
    y: 23.625
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.11,
    y: 0,
    width: 56.96,
    height: 47.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.8125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 553.59,
    y: 23.625
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 582.07,
    y: 0,
    width: 58.12,
    height: 47.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.90625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.13,
    y: 23.625
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.2,
    y: 0,
    width: 59.8,
    height: 47.25,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.1,
    y: 23.625
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 47.25,
    width: 58.4,
    height: 48.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.704
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 71.51
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 95.78,
    width: 58.4,
    height: 48.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 120.05
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 144.31,
    width: 58.4,
    height: 50.47,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.607777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 169.54500000000002
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 194.78,
    width: 58.4,
    height: 50.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 220.17000000000002
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 245.56,
    width: 58.4,
    height: 51.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.279166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 271.235
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 296.91,
    width: 58.4,
    height: 53.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.684000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 323.62
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 350.34,
    width: 58.4,
    height: 55.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 378.13
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 405.91,
    width: 58.4,
    height: 56.32,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 434.07000000000005
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 462.23,
    width: 58.4,
    height: 57.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.351111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 490.81
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 519.39,
    width: 58.4,
    height: 57.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 548.21
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 577.03,
    width: 58.4,
    height: 61.29,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 607.675
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.14,
    y: 638.32,
    width: 58.4,
    height: 61.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.34,
    y: 669.1600000000001
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 47.25,
    width: 55.53,
    height: 65.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.255
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.305,
    y: 80.11
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.07,
    y: 47.25,
    width: 58.93,
    height: 65.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.36625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.535,
    y: 80.11
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 47.25,
    width: 59.79,
    height: 65.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.958
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.895,
    y: 80.11
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.79,
    y: 47.25,
    width: 60.45,
    height: 65.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.55625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.01500000000004,
    y: 80.11
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.24,
    y: 47.25,
    width: 60.58,
    height: 65.72,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.731111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.53000000000003,
    y: 80.11
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.82,
    y: 47.25,
    width: 60.78,
    height: 65.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.21,
    y: 80.11
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.61,
    y: 47.25,
    width: 60.9,
    height: 65.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 478.06,
    y: 80.11
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.5,
    y: 47.25,
    width: 62.07,
    height: 65.72,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.414
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.535,
    y: 80.11
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.57,
    y: 47.25,
    width: 64.18,
    height: 65.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.696666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.6600000000001,
    y: 80.11
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.76,
    y: 47.25,
    width: 65.24,
    height: 65.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.873333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.38,
    y: 80.11
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 112.98,
    width: 70.25,
    height: 62.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 144.435
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 175.89,
    width: 70.25,
    height: 63.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 207.45999999999998
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 239.03,
    width: 70.25,
    height: 63.38,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.054285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 270.72
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 302.41,
    width: 70.25,
    height: 64.45,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 334.63500000000005
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 366.86,
    width: 70.25,
    height: 65.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 399.415
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 431.97,
    width: 70.25,
    height: 65.87,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 464.90500000000003
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 497.84,
    width: 70.25,
    height: 66.34,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 531.01
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 564.17,
    width: 70.25,
    height: 66.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 597.41
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.54,
    y: 630.65,
    width: 70.25,
    height: 69.35,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.3375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.665,
    y: 665.3249999999999
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 112.98,
    width: 72.98,
    height: 67.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.28,
    y: 146.74
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.77,
    y: 112.98,
    width: 74.25,
    height: 67.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.895,
    y: 146.74
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.02,
    y: 112.98,
    width: 76.36,
    height: 67.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.2,
    y: 146.74
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.38,
    y: 112.98,
    width: 78.05,
    height: 67.52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.752
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.405,
    y: 146.74
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.43,
    y: 112.98,
    width: 78.19,
    height: 67.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 502.525,
    y: 146.74
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.62,
    y: 112.98,
    width: 78.3,
    height: 67.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.77,
    y: 146.74
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.93,
    y: 112.98,
    width: 80.07,
    height: 67.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.138181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 659.9649999999999,
    y: 146.74
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 180.49,
    width: 81.82,
    height: 70.69,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.098571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 215.835
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 251.18,
    width: 81.82,
    height: 71.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.938333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 286.995
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 322.82,
    width: 81.82,
    height: 73.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 359.57
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 396.32,
    width: 81.82,
    height: 74.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.592857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 433.395
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 470.47,
    width: 81.82,
    height: 75.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.065999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 508.13500000000005
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 545.8,
    width: 81.82,
    height: 76,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 583.8
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.79,
    y: 621.79,
    width: 81.82,
    height: 78.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.172857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.7,
    y: 660.895
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 180.49,
    width: 83.68,
    height: 77.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.562222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.45000000000005,
    y: 219.02
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.29,
    y: 180.49,
    width: 86.55,
    height: 77.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.565,
    y: 219.02
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.84,
    y: 180.49,
    width: 90.06,
    height: 77.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.87,
    y: 219.02
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.9,
    y: 180.49,
    width: 96.91,
    height: 77.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.562222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 552.355,
    y: 219.02
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.81,
    y: 180.49,
    width: 99.19,
    height: 77.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.405,
    y: 219.02
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 257.55,
    width: 96.44,
    height: 84.88,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.83000000000004,
    y: 299.99
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 342.43,
    width: 96.44,
    height: 85.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.83000000000004,
    y: 385.075
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 427.73,
    width: 96.44,
    height: 88.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.83000000000004,
    y: 472.01
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 516.28,
    width: 96.44,
    height: 91.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.41625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.83000000000004,
    y: 561.9449999999999
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.61,
    y: 607.62,
    width: 96.44,
    height: 92.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.197142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.83000000000004,
    y: 653.81
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.05,
    y: 257.55,
    width: 84.28,
    height: 106.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.19,
    y: 310.65000000000003
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.33,
    y: 257.55,
    width: 90.6,
    height: 106.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.942857142857141
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.63,
    y: 310.65000000000003
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.93,
    y: 257.55,
    width: 92.53,
    height: 106.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.56625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 561.1949999999999,
    y: 310.65000000000003
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.45,
    y: 257.55,
    width: 92.55,
    height: 106.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.509999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 653.725,
    y: 310.65000000000003
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.05,
    y: 363.75,
    width: 99.68,
    height: 102.2,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.613333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.89,
    y: 414.85
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.05,
    y: 465.95,
    width: 99.68,
    height: 109.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.89,
    y: 520.8199999999999
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.05,
    y: 575.7,
    width: 99.68,
    height: 124.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.89,
    y: 637.85
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.73,
    y: 363.75,
    width: 117.61,
    height: 107.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.535,
    y: 417.55
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.34,
    y: 363.75,
    width: 142.66,
    height: 107.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.37142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.6700000000001,
    y: 417.55
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.73,
    y: 471.35,
    width: 162.44,
    height: 103.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.382727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.95,
    y: 522.955
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.73,
    y: 574.56,
    width: 162.44,
    height: 125.44,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.68
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.95,
    y: 637.28
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.17,
    y: 471.35,
    width: 97.83,
    height: 228.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.22875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.0849999999999,
    y: 585.6750000000001
  }, "\n        Buncombe\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1928);
export default __webpack_public_path__ + "static/media/1928.26a82720d843a340f6a974a9f6fec238.svg";
export { ForwardRef as ReactComponent };